const APP_API_URL = "https://api.supermive.com/api";
const APP_BASE_URL = "https://api.supermive.com";
const APP_DEFAULT_LOCALE = "fa";
const APP_LOCALE_LIST = ["fa", "de", "fr", "en"];

export { APP_API_URL, APP_LOCALE_LIST, APP_BASE_URL, APP_DEFAULT_LOCALE };
